import { Link } from 'react-router-dom';
import { products } from '@/mocks/products';

export default function ShopPreview() {
  const featuredProducts = products.slice(0, 4);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-primary-500 font-label text-sm tracking-[0.15em] uppercase mb-3">
            Take Home the Experience
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            Green Tea Shop
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-base">
            Premium Afghan green tea and specialty blends, carefully packaged to
            bring the Ghalib Chai experience to your home.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {featuredProducts.map((product) => (
            <div
              key={product.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 hover:shadow-sm"
            >
              <Link to={`/product/${product.id}`} className="block">
                <div className="relative aspect-square overflow-hidden bg-background-100">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  {product.badge && (
                    <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                      {product.badge}
                    </span>
                  )}
                </div>
                <div className="p-4 md:p-5">
                  <p className="text-xs text-foreground-500 font-label mb-1">
                    {product.category}
                  </p>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                    {product.name}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed mb-3 line-clamp-2">
                    {product.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="font-label text-primary-600 font-semibold text-base">
                      {product.price}
                    </span>
                    <span className="text-foreground-500 text-xs">
                      {product.weight}
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 md:mt-12">
          <Link
            to="/shop"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors"
          >
            Browse All Products
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}